import CheckVerifiedIcon from "@redotech/redo-icons/check-verified-01_filled.svg";
import { Step } from "@redotech/redo-return-core-common/return-flow";
import { verifyItemVariantFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isVerifyItemVariantStepValid,
  VerifyItemVariantState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const VERIFY_ITEM_VARIANT = (
  Details: React.ComponentType<StepTypeDetailsProps<VerifyItemVariantState>>,
): StepType<VerifyItemVariantState, Step.VerifyItemVariant> => ({
  Details: (props) => React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  description: (state) => state.prompt,
  downstream(state) {
    return state.next ? [{ id: state.next }] : [];
  },
  empty: {
    prompt: "Confirm the item matches the expected variant",
    matchLabel: "Match",
    mismatchLabel: "Mismatch",
    scope: "return_item",
  },
  fromModel: (model, id) => verifyItemVariantFromModel(model, id),
  Icon: CheckVerifiedIcon,
  iconColor: "warning",
  layout: () => BlockLayout.FULL,
  maxDownstream: () => 1,
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  stepDeleted(state, stepId) {
    return produce(state, (draft) => {
      if (draft.next === stepId) {
        draft.next = undefined;
      }
    });
  },
  title: STEP_TYPE_NAMES[Step.VERIFY_ITEM_VARIANT],
  toModel(state, id) {
    return {
      type: Step.VERIFY_ITEM_VARIANT,
      customTitle: state.customTitle,
      prompt: state.prompt,
      matchLabel: state.matchLabel,
      mismatchLabel: state.mismatchLabel,
      next: state.next ? id(state.next) : null,
      scope: state.scope,
    };
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(
        `Invalid handle index ${handleIndex} for verify-item-variant step`,
      );
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  valid: (state) => isVerifyItemVariantStepValid(state).valid,
});
